import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Pie } from 'react-chartjs-2';
import moment from 'moment';
import { Card, CardBody, CardTitle, Row, Col, Button } from 'reactstrap';
import {
  FaUsers,
  FaComments,
  FaEnvelope,
  FaPhone,
  FaUser,
  FaBuilding,
  FaIdCard,
  FaGlobe,
  FaCalendarAlt,
  FaBriefcase,
} from 'react-icons/fa';
import { getEmpDashBoard, getEmpDomain } from '../../../redux/MainAction';
import DashboardClock from './DashboardClock';

const EmployeeDashboard = () => {
  const dispatch = useDispatch();
  const dashboardData = useSelector((state) => state?.Webtracker?.empDashboard);
  const domainDetails = dashboardData && dashboardData?.userDetails;
  const taskSummary = dashboardData && dashboardData?.taskSummary;
  const employeeDetails = useSelector((state) => state?.Webtracker?.empDomain);

  const ownId = localStorage.getItem('ownerId');

  useEffect(() => {
    dispatch(getEmpDomain());
    const das = {
      ownerId: ownId,
    };
    dispatch(getEmpDashBoard(das));
  }, [dispatch]);

  const pieData = {
    labels: ['On Time', 'Approaching', 'Missed ', 'Done'],
    datasets: [
      {
        data: [
          dashboardData?.taskSummary?.onTime,
          dashboardData?.taskSummary?.approaching,
          dashboardData?.taskSummary?.missed,
          dashboardData?.taskSummary?.done,
        ],
        backgroundColor: ['#36A2EB', '#F2AE66', '#FF6384', '#77B254'],
        hoverBackgroundColor: ['#36A2EB', '#F2AE66', '#FF6384', '#77B254'],
      },
    ],
  };

  const totalTasks = taskSummary?.total || 1;

  const getProgressWidth = (count) => {
    return `${(count / totalTasks) * 100}%`;
  };

  console.log('domain', dashboardData);

  return (
    <div className="page-content-wrapper">
      <div className="container-fluid">
        <div
          style={{
            marginLeft: '13px',
            fontSize: '22px',
            color: 'black',
            marginTop: '22px',
            marginBottom: '27px',
          }}
        >
          <h2
            className="col-12 text-capitalize font-600 m-0"
            style={{ letterSpacing: '0.15rem' }}
          >
            Welcome, {localStorage.getItem('firstName')}{' '}
            {localStorage.getItem('lastName')}
          </h2>
        </div>

        <Row className="d-flex">
          <Col lg={6} sm={12} className="mb-4 d-flex">
            <Card className="w-100 d-flex flex-column enhanced-card">
              <CardBody className="d-flex flex-column flex-grow-1">
                <CardTitle tag="h5">Employee Details</CardTitle>
                <div className="d-flex justify-content-between align-items-start mt-4 flex-grow-1">
                  <div className="d-flex flex-column">
                    <p className="text-capitalize">
                      <FaUser className="mr-2" />{' '}
                      <span className="font-weight-bold">Name: </span>
                      {employeeDetails?.firstName} {employeeDetails?.lastName}
                    </p>
                    <p>
                      <FaEnvelope className="mr-2" />{' '}
                      <span className="font-weight-bold">Email: </span>
                      {employeeDetails?.email}
                    </p>
                    <p className="text-capitalize">
                      <FaBuilding className="mr-2" />{' '}
                      <span className="font-weight-bold">Domain Name: </span>
                      {domainDetails?.firstName} {domainDetails?.lastName}
                    </p>
                    <p>
                      <FaPhone className="mr-2" />{' '}
                      <span className="font-weight-bold">Domain Contact: </span>{' '}
                      {domainDetails?.userDetail?.mobile}
                    </p>
                    <p>
                      <FaCalendarAlt className="mr-2" />{' '}
                      <span className="font-weight-bold">Created At: </span>
                      {moment(employeeDetails?.createdAt).format('Do MMM, YY')}
                    </p>
                  </div>
                  <div className="text-center align-self-end">
                    <DashboardClock />
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>

          <Col lg={6} sm={12} className="mb-4 d-flex">
            <Card className="w-100 d-flex flex-column enhanced-card">
              <CardBody className="d-flex flex-column flex-grow-1">
                <CardTitle tag="h5">Employee Tasks</CardTitle>
                <div className="d-flex flex-column justify-content-center align-items-center flex-grow-1">
                  <div
                    style={{
                      position: 'relative',
                      width: '100%',
                      maxHeight: '200px',
                    }}
                  >
                    <Pie
                      data={pieData}
                      options={{
                        plugins: {
                          legend: {
                            position: 'top',
                            labels: {
                              boxWidth: 10,
                              usePointStyle: true,
                            },
                          },
                        },
                      }}
                      style={{ margin: 'auto' }}
                    />
                  </div>

                  <hr className="w-100 m-1 mt-3" />

                  <div className="w-100 d-flex justify-content-between align-items-center mt-1">
                    <span className="font-14 task_no2">Open</span>
                    <span className="font-14 task_no">{taskSummary?.open}</span>
                    <div
                      style={{
                        width: '120px',
                        height: '13px',
                        backgroundColor: '#E9ECEF',
                        borderRadius: '10px',
                        overflow: 'hidden',
                      }}
                    >
                      <div
                        style={{
                          width: getProgressWidth(taskSummary?.open),
                          height: '100%',
                          backgroundColor: '#007bff',
                        }}
                      ></div>
                    </div>
                  </div>

                  <hr className="w-100 m-1" />

                  <div className="w-100 d-flex justify-content-between align-items-center mt-1">
                    <span className="font-14 task_no2">Active</span>
                    <span className="font-14 task_no">
                      {taskSummary?.active}
                    </span>
                    <div
                      style={{
                        width: '120px',
                        height: '13px',
                        backgroundColor: '#E9ECEF',
                        borderRadius: '10px',
                        overflow: 'hidden',
                      }}
                    >
                      <div
                        style={{
                          width: getProgressWidth(taskSummary?.active),
                          height: '100%',
                          backgroundColor: '#ffc107',
                        }}
                      ></div>
                    </div>
                  </div>

                  <hr className="w-100 m-1" />

                  <div className="w-100 d-flex justify-content-between align-items-center mt-1">
                    <span className="font-14 task_no2">Done</span>
                    <span className="font-14 task_no">{taskSummary?.done}</span>
                    <div
                      style={{
                        width: '120px',
                        height: '13px',
                        backgroundColor: '#E9ECEF',
                        borderRadius: '10px',
                        overflow: 'hidden',
                      }}
                    >
                      <div
                        style={{
                          width: getProgressWidth(taskSummary?.done),
                          height: '100%',
                          backgroundColor: '#28a745',
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row className="d-flex">
          <Col lg={6} sm={12} className="mb-4 d-flex">
            <Card className="w-100 d-flex flex-column enhanced-card">
              <CardBody className="d-flex flex-column flex-grow-1">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <CardTitle tag="h5">
                    <FaBriefcase className="mr-2" /> Project Activities
                  </CardTitle>
                  {/* <Button tag={Link} to="/domains" color="primary" size="sm">
                  Show All
                </Button> */}
                </div>
                <ul className="list-group flex-grow-1 overflow-auto">
                  {dashboardData?.projectTaskActivities
                    ?.slice(0, 5)
                    .map((user) => (
                      <li
                        key={user.id}
                        className="list-group-item d-flex justify-content-between align-items-center"
                      >
                        <div>
                          <strong>{user?.projectTask?.project?.name}</strong>
                          <p className="mb-0 text-muted">
                            {user?.projectTask?.name}
                          </p>
                        </div>
                        <span>{user?.description}</span>
                      </li>
                    ))}
                </ul>
              </CardBody>
            </Card>
          </Col>

          <Col lg={6} sm={12} className="mb-4 d-flex">
            <Card className="w-100 d-flex flex-column enhanced-card">
              <CardBody className="d-flex flex-column flex-grow-1">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <CardTitle tag="h5">
                    <FaComments className="mr-2" /> Recent Messages
                  </CardTitle>
                  <Button tag={Link} to="/chats" color="primary" size="sm">
                    Show All
                  </Button>
                </div>
                <ul className="list-group flex-grow-1 overflow-auto">
                  {dashboardData?.userChatMessages?.length ? (
                    dashboardData?.userChatMessages?.slice(0, 4).map((chat) => (
                      <li
                        key={chat.id}
                        className={`list-group-item ${chat?.fromId === employeeDetails?.id ? 'text-right' : ''}`}
                      >
                        <strong className="text-capitalize">
                          {chat?.fromId === employeeDetails?.id
                            ? `You (${employeeDetails?.firstName} ${employeeDetails?.lastName})`
                            : `${domainDetails?.firstName} ${domainDetails?.lastName}`}
                        </strong>
                        <p
                          className="mb-0 text-truncate"
                          style={{ maxWidth: '100%' }}
                        >
                          {chat.message}
                        </p>
                        <small className="text-muted">
                          {moment(chat.createdAt).format('MMM D, YYYY hh:mm A')}
                        </small>
                      </li>
                    ))
                  ) : (
                    <div className="text-primary flex-grow-1 d-flex justify-content-center align-items-center">
                      No Recent Chats Found
                    </div>
                  )}
                </ul>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default EmployeeDashboard;
